// "All Calendars" context: a dimmed per-brand entry opens a calendar picker instead of
// navigating without a calendar. The markup is server-rendered; this only positions it.

let popover = null;
let currentAnchor = null;
let documentListenersBound = false;

function hidePopover() {
  currentAnchor = null;
  if (!popover) return;
  popover.hidden = true;
  popover.style.top = '';
  popover.style.left = '';
}

function showPopover(anchor) {
  if (!popover) return;

  popover.hidden = false;

  const rect = anchor.getBoundingClientRect();
  const width = popover.offsetWidth;
  const height = popover.offsetHeight;
  const gap = 12;

  let left = rect.right + gap;
  if (left + width > window.innerWidth - gap) {
    left = Math.max(gap, rect.left - width - gap);
  }

  let top = rect.top;
  if (top + height > window.innerHeight - gap) {
    top = Math.max(gap, window.innerHeight - height - gap);
  }

  popover.style.left = `${left}px`;
  popover.style.top = `${top}px`;
}

function navigationItemFor(anchor) {
  try {
    return anchor.dataset.picoInfo ? JSON.parse(anchor.dataset.picoInfo).navigation_item : null;
  } catch {
    return null;
  }
}

// The server renders every destination per calendar in data-paths.
function applyIntentToCalendarLinks(anchor) {
  if (!popover) return;

  const key = navigationItemFor(anchor) || 'home';

  popover.querySelectorAll('.loomly-ai-needs-calendar-item').forEach((link) => {
    if (!link.dataset.paths) return;

    try {
      const paths = JSON.parse(link.dataset.paths);
      if (paths[key]) link.href = paths[key];
    } catch {
      // Keep the server-rendered home link if the payload is malformed.
    }
  });
}

function bindPopover(popoverElement) {
  popoverElement.addEventListener('click', (event) => {
    const choose = event.target.closest('.js-open-calendar-panel');
    if (!choose) return;

    event.preventDefault();
    // The panel's outside-click handler would close the panel this click opens.
    event.stopPropagation();
    hidePopover();

    const toggle = document.querySelector('.js-calendar-panel-toggle');
    if (toggle) toggle.click();
  });
}

function initPendingQueueNav() {
  // The popover is re-rendered on every visit, so the listeners are bound only once.
  popover = document.getElementById('loomly-ai-needs-calendar');
  if (!popover) return;

  if (popover.dataset.bound !== 'true') {
    popover.dataset.bound = 'true';
    bindPopover(popover);
  }

  if (documentListenersBound) return;
  documentListenersBound = true;

  // Capture phase: the entries' own click handlers (More dropdown, Turbo links) must not
  // run when we open the picker instead.
  document.addEventListener('click', (event) => {
    const anchor = event.target.closest('.js-needs-calendar');
    if (anchor && popover) {
      event.preventDefault();
      event.stopPropagation();

      // Same item toggles; a different item moves the popover to it.
      if (popover.hidden || currentAnchor !== anchor) {
        currentAnchor = anchor;
        applyIntentToCalendarLinks(anchor);
        showPopover(anchor);
        if (window.trackPicoUserAction) {
          window.trackPicoUserAction('pending_actions_needs_calendar_shown', {
            navigation_item: navigationItemFor(anchor)
          });
        }
      } else {
        hidePopover();
      }
      return;
    }

    if (popover && !popover.hidden && !popover.contains(event.target)) {
      hidePopover();
    }
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') hidePopover();
  });

  window.addEventListener('resize', hidePopover);
}

// The panel lives inside the shell's scroll container, which clips it: cap it to that
// container's visible bottom, not to the window's.
function scrollableViewportBottom(element) {
  let node = element.parentElement;

  while (node && node !== document.body) {
    if (getComputedStyle(node).overflowY !== 'visible') {
      return Math.min(window.innerHeight, node.getBoundingClientRect().bottom);
    }
    node = node.parentElement;
  }

  return window.innerHeight;
}

// The filter panel is a plain <details> the server never opens: close it on an outside
// click or Escape like the other popovers.
let filtersDocumentBound = false;

function initPendingFilters() {
  if (filtersDocumentBound) return;
  filtersDocumentBound = true;

  // Cap the panel to the space below its toggle; the actions row is sticky.
  document.addEventListener('toggle', (event) => {
    const filter = event.target;
    if (!filter.classList || !filter.classList.contains('pa-filter') || !filter.open) return;

    const panel = filter.querySelector('.pa-filter-panel');
    const toggle = filter.querySelector('.pa-filter-toggle');
    if (!panel || !toggle) return;

    const space = scrollableViewportBottom(toggle) - toggle.getBoundingClientRect().bottom - 16;
    panel.style.maxHeight = `${Math.max(240, Math.round(space))}px`;
  }, true);

  // The results frame replaces the panel on every visit, so look it up on demand.
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.pa-filter[open]').forEach((filter) => {
      if (filter.contains(event.target)) return;
      filter.open = false;
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.pa-filter[open]').forEach((filter) => {
      filter.open = false;
      filter.querySelector('summary')?.focus();
    });
  });
}

document.addEventListener('turbo:load', initPendingQueueNav);
document.addEventListener('turbo:load', initPendingFilters);
